var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#001220"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#e1685e",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#96446e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#e1685e",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#96446e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#3d3056",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_4",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#3d3056",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#e1685e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#e1685e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#96446e",
    stopOpacity: 1
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#3d3056",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#96446e",
    stopOpacity: 1
  })))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_4",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#3d3056",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 270.4C-16.2 260.4 -32.5 250.4 -48 241.3C-63.5 232.1 -78.2 223.8 -86.5 208.8C-94.7 193.8 -96.5 172 -110 164.6C-123.5 157.3 -148.7 164.3 -156.3 156.3C-163.8 148.3 -153.6 125.2 -175.4 117.2C-197.3 109.3 -251.1 116.4 -249.8 103.5C-248.5 90.6 -192.1 57.7 -186.3 37.1C-180.6 16.5 -225.5 8.2 -270.4 0L0 0Z",
    fill: "#18223c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 216.3C-13 208.3 -26 200.3 -38.4 193C-50.8 185.7 -62.6 179.1 -69.2 167C-75.8 155 -77.2 137.6 -88 131.7C-98.8 125.8 -119 131.4 -125 125C-131 118.6 -122.9 100.2 -140.4 93.8C-157.8 87.4 -200.9 93.1 -199.9 82.8C-198.8 72.5 -153.7 46.1 -149.1 29.7C-144.5 13.2 -180.4 6.6 -216.3 0L0 0Z",
    fill: "#683a67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 162.2C-9.7 156.3 -19.5 150.3 -28.8 144.8C-38.1 139.3 -46.9 134.3 -51.9 125.3C-56.8 116.3 -57.9 103.2 -66 98.8C-74.1 94.4 -89.2 98.6 -93.8 93.8C-98.3 89 -92.2 75.1 -105.3 70.3C-118.4 65.6 -150.7 69.8 -149.9 62.1C-149.1 54.3 -115.3 34.6 -111.8 22.2C-108.4 9.9 -135.3 4.9 -162.2 0L0 0Z",
    fill: "#c0526a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 108.2C-6.5 104.2 -13 100.2 -19.2 96.5C-25.4 92.9 -31.3 89.5 -34.6 83.5C-37.9 77.5 -38.6 68.8 -44 65.9C-49.4 62.9 -59.5 65.7 -62.5 62.5C-65.5 59.3 -61.4 50.1 -70.2 46.9C-78.9 43.7 -100.4 46.6 -99.9 41.4C-99.4 36.2 -76.8 23.1 -74.5 14.8C-72.2 6.6 -90.2 3.3 -108.2 0L0 0Z",
    fill: "#f6884d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 54.1C-3.2 52.1 -6.5 50.1 -9.6 48.3C-12.7 46.4 -15.6 44.8 -17.3 41.8C-18.9 38.8 -19.3 34.4 -22 32.9C-24.7 31.5 -29.7 32.9 -31.3 31.3C-32.8 29.7 -30.7 25 -35.1 23.4C-39.5 21.9 -50.2 23.3 -50 20.7C-49.7 18.1 -38.4 11.5 -37.3 7.4C-36.1 3.3 -45.1 1.6 -54.1 0L0 0Z",
    fill: "#fbae3c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -270.4C11.5 -234.1 23.1 -197.9 38 -191.3C53 -184.6 71.5 -207.7 89.2 -215.3C106.9 -222.9 123.8 -215.1 137.2 -205.4C150.6 -195.7 160.5 -184.2 174.7 -174.7C188.8 -165.2 207.2 -157.7 216.2 -144.4C225.2 -131.2 224.7 -112.2 232.8 -96.4C240.9 -80.7 257.5 -68.3 265.2 -52.8C272.9 -37.2 271.7 -18.6 270.4 0L0 0Z",
    fill: "#18223c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -216.3C9.2 -187.3 18.4 -158.3 30.4 -153C42.4 -147.7 57.2 -166.1 71.3 -172.2C85.5 -178.3 99 -172 109.8 -164.3C120.5 -156.6 128.4 -147.3 139.7 -139.7C151 -132.1 165.8 -126.2 172.9 -115.6C180.1 -105 179.8 -89.7 186.3 -77.1C192.7 -64.6 206 -54.6 212.2 -42.2C218.3 -29.8 217.3 -14.9 216.3 0L0 0Z",
    fill: "#683a67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -162.2C6.9 -140.5 13.8 -118.7 22.8 -114.8C31.8 -110.8 42.9 -124.6 53.5 -129.2C64.1 -133.7 74.3 -129 82.3 -123.2C90.4 -117.4 96.3 -110.5 104.8 -104.8C113.3 -99.1 124.3 -94.6 129.7 -86.7C135.1 -78.7 134.8 -67.3 139.7 -57.9C144.5 -48.4 154.5 -41 159.1 -31.7C163.7 -22.3 163 -11.2 162.2 0L0 0Z",
    fill: "#c0526a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -108.2C4.6 -93.7 9.2 -79.1 15.2 -76.5C21.2 -73.9 28.6 -83.1 35.7 -86.1C42.7 -89.1 49.5 -86 54.9 -82.1C60.3 -78.3 64.2 -73.7 69.9 -69.9C75.5 -66.1 82.9 -63.1 86.5 -57.8C90.1 -52.5 89.9 -44.9 93.1 -38.6C96.4 -32.3 103 -27.3 106.1 -21.1C109.2 -14.9 108.7 -7.4 108.2 0L0 0Z",
    fill: "#f6884d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -54.1C2.3 -46.8 4.6 -39.6 7.6 -38.3C10.6 -36.9 14.3 -41.5 17.8 -43.1C21.4 -44.6 24.8 -43 27.4 -41.1C30.1 -39.1 32.1 -36.8 34.9 -34.9C37.8 -33 41.4 -31.5 43.2 -28.9C45 -26.2 44.9 -22.4 46.6 -19.3C48.2 -16.1 51.5 -13.7 53 -10.6C54.6 -7.4 54.3 -3.7 54.1 0L0 0Z",
    fill: "#fbae3c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.f5a7d75693b8026bf1871f0d9e9a5410.svg";
export { ForwardRef as ReactComponent };